import {getCurrentInstance, computed, reactive} from 'vue';
import {ModuleBudgetItem} from '@/stores/moduleConst';
import {useStore} from 'vuex';
import {MSConstant} from '@/commons/wildcards/index.js';

// Combo grid Tài khoản nợ, có
export const useCacheBudgetItemComboConfig = () => {
  const {proxy} = getCurrentInstance();

  const store = useStore();

  const budgetItemCombo = computed(() => {
    const budgetItems = store.getters[`${ModuleBudgetItem}/items`];
    return budgetItems.filter(x => !x.inactive && x.budget_item_type === MSConstant.BudgetItemType.Item);
  });
  const budgetSubItemCombo = computed(() => {
    const budgetSubItems = store.getters[`${ModuleBudgetItem}/items`];
    return budgetSubItems.filter(x => !x.inactive && x.budget_item_type === MSConstant.BudgetItemType.SubItem);
  });
  const budgetDetailItemCombo = computed(() => {
    const budgetSubItems = store.getters[`${ModuleBudgetItem}/items`];
    return budgetSubItems.filter(x => !x.inactive && x.budget_item_type === MSConstant.BudgetItemType.SubSection);
  });

  // config columns combo
  const cacheBudgetItemComboConfig = reactive({
    data: budgetItemCombo,
    columns: [
      {
        title: 'Mã mục',
        dataField: 'budget_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên mục',
        dataField: 'budget_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_item_code',
    valueField: 'budget_item_code',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'budget_item_code',
      titleSearch: 'Tìm nhanh mục',
    },
  });

  const cacheBudgetSubItemComboConfig = reactive({
    data: budgetSubItemCombo,
    columns: [
      {
        title: 'Mã tiểu mục',
        dataField: 'budget_item_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tiểu mục',
        dataField: 'budget_item_name',
        widht: 480,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'budget_item_code',
    valueField: 'budget_item_code',
    queryMode: 'local',
    modelValueField: 'budget_sub_item_code',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'budget_item_code',
      titleSearch: 'Tìm nhanh tiểu mục',
    },
  });

  const cacheBudgetDetailItemComboConfig = reactive({
    data: budgetDetailItemCombo,
    columns: [
      {
        title: 'Mã tiết tiểu mục',
        dataField: 'budget_item_code',
        width: 130,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tiết tiểu mục',
        dataField: 'budget_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 470,
      },
    ],
    displayField: 'budget_item_code',
    valueField: 'budget_item_code',
    queryMode: 'local',
    dropdownWidth: 600,
    modelValueField: 'budget_detail_item_code',
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'budget_item_code',
      titleSearch: 'Tìm nhanh tiết tiểu mục',
    },
  });

  return {
    cacheBudgetItemComboConfig,
    cacheBudgetSubItemComboConfig,
    cacheBudgetDetailItemComboConfig,
  };
};
